import {makeStyles} from '@material-ui/core/styles';

export const useStyles = makeStyles(({spacing, transitions}) => ({
    pickerView: {
        display: 'flex',
        overflowX: 'hidden',
        flexDirection: 'column',
        height: '310px'
    },
    switchHeader: {
        display: 'flex',
        padding: '0px 10px',
        marginTop: spacing(2),
        justifyContent: 'space-between'
    },
    yearSelectionSwitcher: {
        '& svg': {
            fontSize: '1.8rem'
        }
    },
    yearSwitcher: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: spacing(0, 'auto')
    },
    switchViewDropdown: {
        willChange: 'transform',
        transition: transitions.create('transform'),
        transform: 'rotate(0deg)'
    },
    switchViewDropdownDown: {
        transform: 'rotate(180deg)'
    },
    switchHeaderTransition: {
        flexGrow: 1
    }
}));
